import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

import { generateContactsWebAppConfig } from '@driftt/app-config'
import { Subnav } from '@driftt/tide-subnav'
import { access } from '@driftt/traffic-control'

const hasSegmentsAccess = () => access.hasGates('has_segments_access') || access.isBot()

const SubNavigation = () => {
  const {
    hasContacts,
    hasAccounts,
    hasAudiences,
    hasLiveView
  } = useSelector(state => generateContactsWebAppConfig(state.user))

  const location = useLocation()
  const isDetailsPage = location.pathname.includes('details')

  const audiencesNode = {
    label: 'Audiences',
    hide: !hasAudiences,
    path: '/audiences',
    external: true
  }

  const segmentNodes = {
    label: 'Segments',
    path: '/segments',
    hide: !hasSegmentsAccess(),
    external: true
  }

  const contactsNode = {
    label: 'CONTACTS',
    hide: !hasContacts,
    expanded: true,
    nodes: [
      {
        label: 'All contacts',
        path: '/',
        exact: !isDetailsPage
      },
      {
        label: 'Contact segments',
        path: '/segments',
        exact: false,
        hide: hasSegmentsAccess()
      },
      {
        label: 'Import contacts',
        path: '/imports',
        exact: false
      },
      {
        label: 'Contacts settings',
        path: '/contact-settings'
      },
    ]
  }

  const accountsNode = {
    label: 'ACCOUNTS',
    hide: !hasAccounts,
    expanded: true,
    nodes: [
      {
        label: 'All accounts',
        path: '/accounts',
        hide: !hasAccounts,
        external: true
      },
      {
        label: 'Account segments',
        path: '/accounts/segments',
        hide: !hasAccounts || hasSegmentsAccess(),
        external: true
      },
      {
        label: 'Import accounts',
        path: '/accounts/imports',
        hide: !hasAccounts,
        external: true
      },
    ]
  }

  const liveViewNode = {
    label: 'Live view',
    hide: !hasLiveView,
    path: '/live',
    external: true,
  }

  return (
    <Subnav
      title="Visitors"
      open={true}
      nodes={[
        audiencesNode,
        segmentNodes,
        contactsNode,
        accountsNode,
        liveViewNode
      ]}
    />
  )


}

export default SubNavigation
